import { render, staticRenderFns } from "./MagazaGorevDetayButon.vue?vue&type=template&id=247c41c9"
import script from "./MagazaGorevDetayButon.vue?vue&type=script&lang=js"
export * from "./MagazaGorevDetayButon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports